import { render, staticRenderFns } from "./InviteUrlGenerator.vue?vue&type=template&id=37ec22dc&scoped=true&"
import script from "./InviteUrlGenerator.vue?vue&type=script&lang=js&"
export * from "./InviteUrlGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec22dc",
  null
  
)

export default component.exports